import React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

import styles from './product-thumbnail-component.module.css';

export const ProductThumbnailLoader: React.FC = React.memo(() => {
    return (
        <div className={`${styles.container} ${styles.noHover}`}>
            <Placeholder>
                <Placeholder.Image className={styles.imagePlaceholder} />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="full" />
                <Placeholder.Line length="medium" />
            </Placeholder>
        </div>
    );
});
